import React, { useState } from "react";
//outsource
import { Row, Col, Table, Space, Button } from "antd";
import { BsCheckAll } from "react-icons/bs";
//components
import {
  getHeaderByRangeEdit,
  getDataRowsEdit,
} from "../../../utils/refine.timetracking";

//redux
import { useDispatch, useSelector } from "react-redux";
import { setEdit } from "../../../store/report/report.action";
import {
  reportDataSelector,
  rangeSelector,
} from "../../../store/report/report.selector";

const TimeTableEdit = ({ loading, onUpdate, selected, setSelected }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const reportData = useSelector(reportDataSelector);
  const range = useSelector(rangeSelector);
  console.log({ selected });
  // -------------------------- FUNCTION --------------------------
  const closeEdit = () => {
    dispatch(setEdit({ data: false }));
    setSelected([]);
  };

  const selectedUpdateTime = (update, select) => {
    // console.log({ update });
    let action = update === null ? "delete" : select?.action;
    let data = {
      ...select,
      time: update,
      action,
    };

    //check unique
    const final =
      selected?.length > 0 ? selected?.map((item) => item?.unique) : [];
    if (!final?.includes(select?.unique)) {
      setSelected((selected) => [...selected, data]);
    } else {
      let update = selected?.map((item) =>
        item?.unique === data?.unique ? data : item
      );
      setSelected(update);
    }
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const columns = getHeaderByRangeEdit(range);
  const dataRange = getDataRowsEdit(reportData, range, selectedUpdateTime);

  const renderButtonGroup = () => {
    return (
      <Space size="small">
        <Button loading={loading} type="default" onClick={closeEdit}>
          Cancel
        </Button>
        <Button
          style={{ backgroundColor: "green", border: 0 }}
          icon={
            <span className="anticon">
              <BsCheckAll />
            </span>
          }
          type="primary"
          onClick={onUpdate}
          loading={loading}
        >
          Confirm
        </Button>
      </Space>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Row>
      {" "}
      <Col style={{ marginBottom: 10 }} align="right" span={24}>
        {renderButtonGroup()}
      </Col>
      <Col span={24}>
        <Table
          bordered
          columns={columns}
          dataSource={dataRange || []}
          pagination= {false}
        />
      </Col>
    </Row>
  );
};

export default TimeTableEdit;
